import './maps.scss';


const maps = () => {
    document.getElementById('file-input')?.addEventListener('change', displayFileName);


    function displayFileName() {
        console.log("displayFileName");

        var fileInput = document.getElementById('file-input');
        var result = document.querySelector('.input-wrapper .result');
        if (fileInput.files.length > 0) {
            console.log("fileInput.files.length > 0");
            result.innerHTML = 'File selezionato: ' + fileInput.files[0].name;
        }
    }
}

export default maps;